import { EventBlock } from "@iventis/domain-model/model/eventBlock";
import { EventBlockSystemDataFieldType } from "@iventis/domain-model/model/eventBlockSystemDataFieldType";
import { Hierarchy } from "@iventis/domain-model/model/hierarchy";
import { ScheduleVersion } from "@iventis/domain-model/model/scheduleVersion";
import { VenueLocation } from "@iventis/domain-model/model/venueLocation";
import { getDataFieldValueAsText, getDataFieldValueAsTextFromEntity } from "@iventis/utilities";
import { findHierarchyEntityById } from "./hierarchy.helpers";
import { FilterType } from "./filter-rules";
import { getSystemDataFieldFromEventBlock } from "./data-field-helpers";
import { SportEventDataFieldNames, NoMedalType } from "./datafields";

export enum SportsScheduleEntityType {
    disciplineSchedule = "Discipline schedule",
    schedule = "Schedule",
}

export enum ViewType {
    Venue = "Venue",
    Discipline = "Discipline",
    None = "None",
}

export const getViewTypeString = (eventBlock: EventBlock, scheduleVersionHierarchy: Hierarchy<ScheduleVersion>, viewType: ViewType): string =>
    viewType === ViewType.Venue
        ? getDisciplineValue(findHierarchyEntityById([scheduleVersionHierarchy], eventBlock.scheduleVersionId)?.item as ScheduleVersion)?.toString()
        : eventBlock.venueLocation.name;

export const getCalendarSessionText = (
    eventBlock: EventBlock,
    scheduleVersionHierarchy: Hierarchy<ScheduleVersion>,
    filterType?: FilterType
): { name: string; description: string } => {
    let eventBlockDescription = eventBlock.description;
    if (!eventBlockDescription) {
        switch (filterType) {
            case FilterType.DayVenue: {
                eventBlockDescription = getDisciplineValue(findHierarchyEntityById([scheduleVersionHierarchy], eventBlock.scheduleVersionId)?.item as ScheduleVersion)?.name || "";
                break;
            }
            case FilterType.DayDataField: {
                eventBlockDescription = eventBlock.venueLocation.name;
                break;
            }
            default: {
                eventBlockDescription = getDisciplineValue(findHierarchyEntityById([scheduleVersionHierarchy], eventBlock.scheduleVersionId)?.item as ScheduleVersion)?.name || "";
                break;
            }
        }
    }

    const eventBlockName = getDataFieldValueAsText(getSystemDataFieldFromEventBlock(EventBlockSystemDataFieldType.Code, eventBlock)); // In this case, the name is the datafield discipline
    return {
        name: eventBlockName,
        description: eventBlockDescription,
    };
};
export const isSessionAMedalEvent = (eventBlock: EventBlock) => isStringAMedalEvent(getDataFieldValueAsTextFromEntity(eventBlock, SportEventDataFieldNames.MEDAL_TYPE));

export const isStringAMedalEvent = (stringIn: string) => stringIn !== NoMedalType;

export const getDisciplineValue = (scheduleVersion: ScheduleVersion) => getDataFieldValueAsTextFromEntity(scheduleVersion, SportEventDataFieldNames.DISCIPLINE);

export const getVenueCodeAndName = (venueLocation: VenueLocation): string => {
    if (!venueLocation) {
        return null;
    }
    const code = getDataFieldValueAsTextFromEntity(venueLocation, SportEventDataFieldNames.VENUE_CODE);
    if (code) {
        return `${code} (${venueLocation.name})`;
    }
    return venueLocation.name;
};
